<template lang="pug">

    div

        //- Welcher Proof wird benoetigt
        .inline.fields

            //- Kein Proof
            .field
                .ui.radio.checkbox
                    input#iwno(type='radio' name='isWanted' v-model="isWanted" value="NO")
                    label(for='iwno') Kein Proof

            //- Hardproof
            .field
                .ui.radio.checkbox
                    input#iwhp(type='radio' name='isWanted' v-model="isWanted" value="HARDPROOF")
                    label(for='iwhp') Hardproof

        //- Vorauftragsmuster verwenden (ID)
        text-field(
            label='Vorauftragsmuster verwenden (ID)'
            v-model="previousJob"
            v-show="isWanted === 'HARDPROOF'"
        )

        //- Proof an
        .two.fields(v-show="isWanted === 'HARDPROOF'")
            .field
                label Proof an
            .field
                label Anzahl

        address-row(
            v-for='(address, index) in addresses'
            v-bind:key='address.id'
            v-bind:address-models='shippingAddressModels'
            v-bind:value='addresses[index]'
            v-on:input='updateAddresses($event, index)'
            v-show="isWanted === 'HARDPROOF'"
        )

        .field(v-show="isWanted === 'HARDPROOF'")
            .ui.grid
                .right.aligned.column
                    a.ui.right.labeled.icon.button(v-on:click='addAddress()')
                        i.plus.icon
                        | Adresse hinzufügen

        //- Format
        dropdown-field(
            label='Format'
            optionLabel='label'
            optionValue='key'
            v-bind:options='formatOptions'
            v-model='format'
            v-show="isWanted === 'HARDPROOF'"
        )

        //- Bemerkung
        text-field(
            label='Bemerkung'
            v-model="note"
            v-show="isWanted === 'HARDPROOF'"
        )

</template>

<script>
    import * as R from 'ramda'
    import DropdownField from '@/components/form/DropdownField.vue'
    import Error from '@/components/form/FieldError.vue'
    import NumberField from '@/components/form/NumberField.vue'
    import TextField from '@/components/form/TextField.vue'
    import AddressRow from './proof-form/AddressRow'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { AddressRow, DropdownField, Error, NumberField, TextField },

        computed: {

            addresses() {
                return R.compose(

                    // Pruefen ob mindestens eine Adresse vorhanden ist
                    R.when(R.propEq('length', 0), R.always([{}])),

                    // ggf. Standardwert setzen
                    R.defaultTo([{}])

                )(this.value.to)
            },

            format: {
                get() { return this.value.format },
                set(value) { this.updateValue('format', value) }
            },

            isWanted: {
                get() { return this.value.isWanted },
                set(value) {
                    R.compose(

                        // `input`-Event auslösen
                        model => this.$emit('input', model),

                        // ggf. Properties resetten
                        R.when(() => R.equals('NO', value), R.compose(
                            R.set(R.lensProp('format'), undefined),
                            R.set(R.lensProp('previousJob'), undefined),
                            R.set(R.lensProp('note'), undefined),
                            R.set(R.lensProp('to'), []),
                        )),

                        // Wert setzen
                        R.set(R.lensProp('isWanted'), value)

                    )(this.value)
                }
            },

            note: {
                get() { return this.value.note },
                set(value) { this.updateValue('note', value) }
            },

            previousJob: {
                get() { return this.value.previousJob },
                set(value) { this.updateValue('previousJob', value) }
            }
        },

        data() {
            return {
                formatOptions: [
                    { key: 'A4_SINGLE', label: 'A4 - Einzelproof' },
                    { key: 'A4_DERIVED', label: 'A4 - Folgeproof' },
                    { key: 'A3_SINGLE', label: 'A3 - Einzelproof' },
                    { key: 'A3_DERIVED', label: 'A3 - Folgeproof' },
                    { key: 'A2_SINGLE', label: 'A2 - Einzelproof' },
                    { key: 'A2_DERIVED', label: 'A2 - Folgeproof' },
                ]
            }
        },

        methods: {

            addAddress() {
                this.updateValue('to', R.append({}, this.addresses))
            },

            updateAddresses(value, index) {
                this.$emit('input', R.assoc('to', R.update(index, value, this.addresses), this.value))
            },

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

        },

        props: {

            shippingAddressModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        },

    }

</script>
